import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from '../../../global.service';

@Component({
  selector: 'app-politica-privacidad',
  templateUrl: './politica-privacidad.component.html',
  styleUrls: ['./politica-privacidad.component.sass']
})
export class PoliticaPrivacidadComponent implements OnInit {
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public type;
  public tabActive='Compras';
  public selectBan;
  public token:string=sessionStorage.getItem("token");
  public selTab: number;
  constructor(private router: Router,private route: ActivatedRoute,private global:GlobalService) { }

  ngOnInit() {
    this.selTab = 1;
    this.getId();
  }
  statusChange(sw) {
    this.global.validateSession();
    this.selTab = sw;
  }
  getId() {
    if (this.route.firstChild) {
      var id = this.route.firstChild.snapshot.params.id;
      if (id == '1') {
        this.selTab = 1;
      }
      else if (id == '2') {
        this.selTab = 2;
      }
      else if (id == '3') {
        this.selTab = 3;
      }
      else {
        this.selTab = 1;
        this.router.navigate(['usage']);
      }
    }
  } 

}
